var map = {
	"./ico-bnb.png": 99064,
	"./ico-btc.png": 30723,
	"./ico-eth.png": 15271,
	"./ico-ltc.png": 83309,
	"./ico-ton.png": 15113,
	"./ico-toncoin--color.png": 77039,
	"./ico-usdc.png": 40031,
	"./ico-usdt.png": 44112,
	"./ico-usdt2.png": 49120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63739;